import { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { passwordApi } from '../api/settingsApi';
import { Logo } from '../components/Logo';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const mutation = useMutation({
    mutationFn: (email: string) => passwordApi.forgot(email),
    onSuccess: () => setDone(true),
  });

  return (
    <>
      <Helmet>
        <title>Zapomenuté heslo | HasičiOnline.cz</title>
      </Helmet>
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'background.default' }}>
        <Container maxWidth="sm">
          <Stack spacing={3} alignItems="center">
            <Logo size={64} />
            <Card sx={{ width: '100%', boxShadow: 4 }}>
              <CardContent sx={{ p: 4 }}>
                {!done ? (
                  <Stack spacing={3}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" fontWeight={700} gutterBottom>
                        Zapomenuté heslo
                      </Typography>
                      <Typography color="text.secondary" variant="body2">
                        Zadejte e-mailovou adresu spojenou s vaším účtem.
                      </Typography>
                    </Box>
                    <Box
                      component="form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        mutation.mutate(email);
                      }}
                    >
                      <Stack spacing={2}>
                        <TextField
                          label="E-mail"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          fullWidth
                          required
                          autoFocus
                        />
                        <Button
                          type="submit"
                          variant="contained"
                          size="large"
                          disabled={mutation.isPending || !email}
                        >
                          {mutation.isPending ? 'Odesílám…' : 'Odeslat odkaz'}
                        </Button>
                      </Stack>
                    </Box>
                  </Stack>
                ) : (
                  <Stack spacing={2} alignItems="center">
                    <Alert severity="success" sx={{ width: '100%' }}>
                      Pokud e-mail existuje v systému, dostanete během chvíle zprávu s odkazem pro reset hesla.
                    </Alert>
                    <Button component={RouterLink} to="/login">
                      Zpět na přihlášení
                    </Button>
                  </Stack>
                )}
              </CardContent>
            </Card>
            <Button component={RouterLink} to="/login" variant="text">
              Zpět na přihlášení
            </Button>
          </Stack>
        </Container>
      </Box>
    </>
  );
};
